/**
 * The song card is a fixed height everywhere it renders (chat bubble, a post
 * with no media), so a chat row's height estimate and the feed's layout never
 * wait on it. Change `SongCard` and this together.
 */
export const SONG_CARD_HEIGHT = 88;
